// =============================================================================
// Org/tenant selection — mobile counterpart to Programme's
// src/shared/tenantSelection.js, for an identity with an active seat in more
// than one tenant (e.g. a contractor who's a guest in several customers'
// accounts).
//
// Kept in memory only (module-level variable, NOT SecureStore/AsyncStorage):
// it resets on every fresh app launch and is cleared explicitly on sign out
// (see auth.js signOut() / ProjectSelectScreen.js handleSignOut), so a new
// sign-in never silently reuses a tenant choice made under a previous
// account. This mirrors why the web app uses sessionStorage rather than
// localStorage — see Programme's tenantSelection.js for the cross-account
// leak that persisted storage caused there.
//
// The chosen tenant is attached as an `x-tenant-id` header on API calls —
// a hint only: the server (resolveTenant.js) always re-checks that the
// signed-in identity actually has a seat in the named tenant before
// honouring it.
// =============================================================================

let selectedTenantId = '';

export function getSelectedTenantId() {
  return selectedTenantId;
}

export function setSelectedTenantId(tenantId) {
  selectedTenantId = tenantId || '';
}
